import { useParams } from '@tanstack/react-router';
import { useParamsSearch } from '@anytag/shared-hooks';
import { InstagramHashtagsAnalyticsSearchSchemaType } from '../schemaTypes';

export const useInstagramHashtagsAnalyticsFilter = () => {
  const params = useParams({ strict: false });
  const paramsSearch = useParamsSearch<InstagramHashtagsAnalyticsSearchSchemaType>();

  return { ...paramsSearch, countryId: (params.countryId || 'jp').toUpperCase() };
};
